import * as React from 'react'
import classNames from 'classnames'

import classes from './style.module.scss'

interface ComponentProps {
  children?: React.ReactNode
  className?: string
}

export const Accordion: React.FC<ComponentProps> = (props) => {
  const {
    children,
    className,
  } = props

  return (
    <div className={classNames(classes.container, className)}>
      {children}
    </div>
  )
}

Accordion.defaultProps = {
  className: undefined,
}